import { render, staticRenderFns } from "./SlidingMenuComponent.vue?vue&type=template&id=c5d015ba&scoped=true"
import script from "./SlidingMenuComponent.vue?vue&type=script&lang=js"
export * from "./SlidingMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./SlidingMenuComponent.vue?vue&type=style&index=0&id=c5d015ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d015ba",
  null
  
)

export default component.exports